import { Button, Box, Card, CardActions, CardContent, Container, Typography } from "@mui/material";
import CelebrationIcon from '@mui/icons-material/Celebration';
import { Link } from "react-router-dom";

export default function CheckoutError() {
  return (
    <Container sx={{ p: 3 }} maxWidth="md">
      <Card>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center' }}>
            <CelebrationIcon sx={{ fontSize: 72 }} color="primary" />
          </Box>
          <Typography sx={{ textAlign: 'center', mt: 2 }} variant="h3">
            Thanks for your purchase! 
          </Typography>
          <Typography sx={{ textAlign: 'center', mt: 2 }}>
            You should be ready to rock and roll.
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center' }}>
          <Button component={Link} to="/account/" variant="outlined">Account</Button>
        </CardActions>
      </Card>
    </Container>
  );
}